var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.lastUpdated)?_c('div',{staticClass:"table-last-updated-component"},[_c('p',[_vm._v("Last updated: "+_vm._s(_vm.lastUpdated))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }